<ng-container [formGroup]="orderEditingService.form.get('template.edits')">
  <pdq-card variant="flat" color="white">
    <div class="card-container">
      <pdq-collapsed #productCollapsed [initialCollapsed]="false" id="order-editing-product" [cacheState]="true">
        <pdq-collapsed-header>
          <div class="card-header" [class.collapsed]="productCollapsed.collapsed">
            <pdq-heading element="h6">Product</pdq-heading>
            <pdq-collapsed-trigger [class.collapsed]="productCollapsed.collapsed">
              <pdq-icon icon="arrow_down" color="var(--on-surface-light)"></pdq-icon>
            </pdq-collapsed-trigger></div
        ></pdq-collapsed-header>
        <pdq-collapsed-content>
          <pdq-divider></pdq-divider>

          <div class="card-body" [formGroupName]="'product'">
            <pdq-slide-toggle
              formControlName="variant"
              togglePosition="right"
              label="Change product option"
              subtext="Let customers switch to a different variant (e.g. size or color)"></pdq-slide-toggle>
            <div class="edit-product-quantity-container">
              <pdq-slide-toggle
                formControlName="quantity"
                togglePosition="right"
                subtext="Let customers increase or decrease item quantities"
                label="Change item quantity"></pdq-slide-toggle>
              @if (orderEditingService.form.get('template.edits.product.quantity')?.value) {
                <pdq-banner variant="attention" [inline]="true" [closable]="false">
                  <p class="body-12-regular">
                    <span class="body-12-medium">Note:</span> Shipping fees aren’t recalculated when orders are edited.
                    New items ship at the original rate, which may not match actual costs.
                  </p>
                </pdq-banner>
              }
            </div>
            <pdq-slide-toggle
              formControlName="addProducts"
              togglePosition="right"
              label="Add Products"
              subtext="Let customers add products from the store's catalog"></pdq-slide-toggle>
            <pdq-slide-toggle
              formControlName="orderNote"
              togglePosition="right"
              label="Add/Edit order note"
              subtext="Let customers add a note to their order"></pdq-slide-toggle>

            <pdq-slide-toggle
              formControlName="cancelOrder"
              togglePosition="right"
              label="Allow order cancelation"
              subtext="Let customers cancel their order after checkout"></pdq-slide-toggle>
            <pdq-slide-toggle
              formControlName="changeFulfillmentLocation"
              togglePosition="right"
              subtext="Let customers edit orders even if items ship from different locations"
              label="Allow edits across warehouses"></pdq-slide-toggle>
            <pdq-slide-toggle
              formControlName="outOfStockProducts"
              togglePosition="right"
              subtext="Let customers edit orders to include items that aren’t currently in stock"
              label="Allow out-of-stock items"></pdq-slide-toggle>
            <pdq-slide-toggle
              formControlName="discountCode"
              togglePosition="right"
              subtext="Let customers apply a discount code to their order after checkout"
              label="Allow Apply Discount Code"></pdq-slide-toggle>
          </div>
        </pdq-collapsed-content>
      </pdq-collapsed>
    </div>
  </pdq-card>
  <pdq-card variant="flat" color="white">
    <div class="card-container">
      <pdq-collapsed #customerCollapsed [initialCollapsed]="false" id="order-editing-customer" [cacheState]="true">
        <pdq-collapsed-header>
          <div class="card-header" [class.collapsed]="customerCollapsed.collapsed">
            <pdq-heading element="h6">Customer details</pdq-heading>
            <pdq-collapsed-trigger [class.collapsed]="customerCollapsed.collapsed">
              <pdq-icon icon="arrow_down" color="var(--on-surface-light)"></pdq-icon>
            </pdq-collapsed-trigger>
          </div>
        </pdq-collapsed-header>
        <pdq-collapsed-content>
          <pdq-divider></pdq-divider>
          <div class="card-body">
            <ng-container [formGroupName]="'customerDetails'">
              <pdq-slide-toggle
                formControlName="shippingAddress"
                togglePosition="right"
                label="Change shipping details"
                subtext="Let customers update their shipping address or info"></pdq-slide-toggle>
              <pdq-slide-toggle
                [disabled]="!shippingAddressControl.value"
                formControlName="allowEditPhone"
                togglePosition="right"
                label="Edit customer phone number"></pdq-slide-toggle>
              <pdq-slide-toggle
                [disabled]="!shippingAddressControl.value"
                formControlName="allowEditEmail"
                togglePosition="right"
                label="Edit customer email"></pdq-slide-toggle>
              <pdq-slide-toggle
                [disabled]="!shippingAddressControl.value"
                formControlName="allowChangingDestinationCountry"
                togglePosition="right"
                label="Allow Changing Destination Country"></pdq-slide-toggle>
              <pdq-slide-toggle
                [disabled]="!shippingAddressControl.value"
                formControlName="allowTaxRecalculation"
                togglePosition="right"
                subtext="Adjusts taxes on address changes. May remove custom product details (gift messages, personalizations)."
                label="Allow Tax Recalculation"></pdq-slide-toggle>
            </ng-container></div
        ></pdq-collapsed-content>
      </pdq-collapsed>
    </div>
  </pdq-card>
  <pdq-card variant="flat" color="white">
    <div class="card-container">
      <pdq-collapsed #rulesCollapsed [initialCollapsed]="false" id="order-editing-rules" [cacheState]="true">
        <pdq-collapsed-header>
          <div class="card-header" [class.collapsed]="rulesCollapsed.collapsed">
            <div class="header-content">
              <pdq-heading element="h6">Display Conditions</pdq-heading>
              <span class="header-subtext">Define when order editing will be shown</span>
            </div>
            <pdq-collapsed-trigger [class.collapsed]="rulesCollapsed.collapsed">
              <pdq-icon icon="arrow_down" color="var(--on-surface-light)"></pdq-icon>
            </pdq-collapsed-trigger>
          </div>
        </pdq-collapsed-header>
        <pdq-collapsed-content>
          <div
            class="card-body"
            [class.rules-disabled]="!orderEditingService.form.get('template.edits.rulesEnabled').value">
            <pdq-rules-dynamic-form
              [formGroup]="orderEditingService.form.get('template.edits')"
              [formArrayFieldName]="'rules'"
              [rules]="restrictionsRules | addCurrencyOption: shopService.shopCurrencySymbol"
              [entities]="entities"
              [shopCurrencySymbol]="shopService.shopCurrencySymbol"
              [versionWithOrOperator]="true"></pdq-rules-dynamic-form></div
        ></pdq-collapsed-content>
      </pdq-collapsed>
    </div>
  </pdq-card>
</ng-container>
